const WXFaceMap = [
    {
        key: 'wx',
        text: '微笑',
        code: 14,
    },
    {
        key: 'pz',
        text: '撇嘴',
        code: 1,
    },
    {
        key: 'se',
        text: '色',
        code: 2,
    },
    {
        key: 'fd',
        text: '发呆',
        code: 3,
    },
    {
        key: 'dy',
        text: '得意',
        code: 4,
    },
    {
        key: 'll',
        text: '流泪',
        code: 5,
    },
    {
        key: 'hx',
        text: '害羞',
        code: 6,
    },
    {
        key: 'bz',
        text: '闭嘴',
        code: 7,
    },
    {
        key: 'shui',
        text: '睡',
        code: 8,
    },
    {
        key: 'dk',
        text: '大哭',
        code: 9,
    },
    {
        key: 'gg',
        text: '尴尬',
        code: 10,
    },
    {
        key: 'fn',
        text: '发怒',
        code: 11,
    },
    {
        key: 'tp',
        text: '调皮',
        code: 12,
    },
    {
        key: 'cy',
        text: '呲牙',
        code: 13,
    },
    {
        key: 'jy',
        text: '惊讶',
        code: 0,
    },

    {
        key: 'ng',
        text: '难过',
        code: 15,
    },
    {
        key: 'lengh',
        text: '囧',
        code: 96,
    },
    {
        key: 'zk',
        text: '抓狂',
        code: 18,
    },

    {
        key: 'tuu',
        text: '吐',
        code: 19,
    },
    {
        key: 'tx',
        text: '偷笑',
        code: 20,
    },
    {
        key: 'ka',
        text: '愉快',
        code: 21,
    },
    {
        key: 'baiy',
        text: '白眼',
        code: 22,
    },
    {
        key: 'am',
        text: '傲慢',
        code: 23,
    },
    {
        key: 'kun',
        text: '困',
        code: 25,
    },
    {
        key: 'jk',
        text: '惊恐',
        code: 26,
    },
    {
        key: 'lh',
        text: '流汗',
        code: 27,
    },
    {
        key: 'hanx',
        text: '憨笑',
        code: 28,
    },
    {
        key: 'db',
        text: '悠闲',
        code: 29,
    },
    {
        key: 'fendou',
        text: '奋斗',
        code: 30,
    },
    {
        key: 'zhm',
        text: '咒骂',
        code: 31,
    },
    {
        key: 'yiw',
        text: '疑问',
        code: 32,
    },
    {
        key: 'xu',
        text: '嘘',
        code: 33,
    },
    {
        key: 'yun',
        text: '晕',
        code: 34,
    },

    {
        key: 'shuai',
        text: '衰',
        code: 36,
    },
    {
        key: 'kl',
        text: '骷髅',
        code: 37,
    },
    {
        key: 'qiao',
        text: '敲打',
        code: 38,
    },
    {
        key: 'zj',
        text: '再见',
        code: 39,
    },
    {
        key: 'ch',
        text: '擦汗',
        code: 97,
    },
    {
        key: 'kb',
        text: '抠鼻',
        code: 98,
    },
    {
        key: 'gz',
        text: '鼓掌',
        code: 99,
    },
    {
        key: 'huaix',
        text: '坏笑',
        code: 101,
    },
    {
        key: 'zhh',
        text: '左哼哼',
        code: 102,
    },
    {
        key: 'yhh',
        text: '右哼哼',
        code: 103,
    },
    {
        key: 'hq',
        text: '哈欠',
        code: 104,
    },

    {
        key: 'bs',
        text: '鄙视',
        code: 105,
    },
    {
        key: 'wq',
        text: '委屈',
        code: 106,
    },
    {
        key: 'kk',
        text: '快哭了',
        code: 107,
    },
    {
        key: 'yx',
        text: '阴险',
        code: 108,
    },
    {
        key: 'qq',
        text: '亲亲',
        code: 109,
    },
    {
        key: 'kel',
        text: '可怜',
        code: 111,
    },
    {
        key: 'cd',
        text: '菜刀',
        code: 112,
    },
    {
        key: 'xig',
        text: '西瓜',
        code: 89,
    },
    {
        key: 'pj',
        text: '啤酒',
        code: 113,
    },
    {
        key: 'kf',
        text: '咖啡',
        code: 60,
    },
    {
        key: 'zt',
        text: '猪头',
        code: 46,
    },
    {
        key: 'mg',
        text: '玫瑰',
        code: 63,
    },
    {
        key: 'dx',
        text: '凋谢',
        code: 64,
    },
    {
        key: 'sa',
        text: '嘴唇',
        code: 116,
    },
    {
        key: 'xin',
        text: '爱心',
        code: 66,
    },

    {
        key: 'xs',
        text: '心碎',
        code: 67,
    },
    {
        key: 'dg',
        text: '蛋糕',
        code: 53,
    },
    {
        key: 'zhd',
        text: '炸弹',
        code: 55,
    },
    {
        key: 'bb',
        text: '便便',
        code: 59,
    },
    {
        key: 'yl',
        text: '月亮',
        code: 75,
    },
    {
        key: 'ty',
        text: '太阳',
        code: 74,
    },
    {
        key: 'yb',
        text: '拥抱',
        code: 49,
    },
    {
        key: 'qiang',
        text: '强',
        code: 76,
    },
    {
        key: 'ruo',
        text: '弱',
        code: 77,
    },
    {
        key: 'ws',
        text: '握手',
        code: 78,
    },
    {
        key: 'shl',
        text: '胜利',
        code: 79,
    },

    {
        key: 'bq',
        text: '抱拳',
        code: 118,
    },
    {
        key: 'gy',
        text: '勾引',
        code: 119,
    },
    {
        key: 'qt',
        text: '拳头',
        code: 120,
    },
    {
        key: 'hd',
        text: 'OK',
        code: 124,
    },
    {
        key: 'tiao',
        text: '跳跳',
        code: 43,
    },
    {
        key: 'fad',
        text: '发抖',
        code: 41,
    },
    {
        key: 'oh',
        text: '怄火',
        code: 86,
    },
    {
        key: 'zhq',
        text: '转圈',
        code: 125,
    },
    {
        key: 'e-xl',
        text: '😄',
        alias: '笑脸',
    },
    {
        key: 'e-ptwx',
        text: '😂',
        alias: '破涕为笑',
    },
    {
        key: 'e-ts',
        text: '😝',
        alias: '吐舌',
    },
    {
        key: 'e-lh',
        text: '😳',
        alias: '脸红',
    },
    {
        key: 'e-kj',
        text: '😱',
        alias: '恐惧',
    },
    {
        key: 'e-ng',
        text: '😔',
        alias: '失望',
    },
    {
        key: 'e-wy',
        text: '😒',
        alias: '无语',
    },
    {
        key: 'e-hs',
        text: '🙏',
        alias: '合十',
    },
    {
        key: 'e-qz',
        text: '💪',
        alias: '强壮',
    },
    {
        key: 'e-qingz',
        text: '🎉',
        alias: '庆祝',
    },
];
export { WXFaceMap };
